/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsFusionAppSetting
 */
export interface FusionMelcoFusionModelsFusionAppSetting {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsFusionAppSetting
     */
    measurement_unit: string;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsFusionAppSetting
     */
    default_embroidery_production_file_format: string;
    /**
     * 
     * @type {boolean}
     * @memberof FusionMelcoFusionModelsFusionAppSetting
     */
    enable_production_links: boolean;
}

export function FusionMelcoFusionModelsFusionAppSettingFromJSON(json: any): FusionMelcoFusionModelsFusionAppSetting {
    return FusionMelcoFusionModelsFusionAppSettingFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsFusionAppSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsFusionAppSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurement_unit': json['measurement_unit'],
        'default_embroidery_production_file_format': json['default_embroidery_production_file_format'],
        'enable_production_links': json['enable_production_links'],
    };
}

export function FusionMelcoFusionModelsFusionAppSettingToJSON(value?: FusionMelcoFusionModelsFusionAppSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurement_unit': value.measurement_unit,
        'default_embroidery_production_file_format': value.default_embroidery_production_file_format,
        'enable_production_links': value.enable_production_links,
    };
}


